<form
    [formGroup]="formGroup"
    (ngSubmit)="handleSubmit()"
>
    <div class="grid-container vertical-gutter-lg">
        <div class="form-control g-12 lg:g-6">
            <label for="email-input">E-mail*: </label>
            <input
                id="email-input"
                type="email"
                [formControl]="formGroup.controls.email"
                placeholder="E-mail*"
            />
            @if (formGroup.controls.email.touched && formGroup.controls.email.invalid) {
                <span
                    class="form-error-note"
                    aria-live="polite"
                    >Bitte gib eine valide E-Mail-Adresse an.</span
                >
            }
        </div>
        <p class="g-12 fs:s">
            Dein Passwort muss mindestens acht Zeichen lang sein und sollte Groß- wie Kleinbuchstaben, Ziffern und
            Sonderzeichen (z.B. %&$! usw.) enthalten. Wenn du dein Passwort nicht ändern willst lass die unten stehenden
            Felder einfach leer.
        </p>
        <div class="form-control g-12">
            <label for="password-input">Neues Passwort: </label>
            <app-toggle-password>
                <input
                    id="password-input"
                    #passwordInput
                    type="password"
                    [formControl]="formGroup.controls.newPassword"
                    placeholder="Neues Passwort"
                    autocomplete="new-password"
                />
                @if (formGroup.controls.newPassword.touched && formGroup.controls.newPassword.invalid) {
                    <span
                        class="form-error-note"
                        aria-live="polite"
                        >Das Passwort sollte mindestens 8 Zeichen lang sein.</span
                    >
                }
            </app-toggle-password>
        </div>
        <div class="form-control g-12">
            <label for="password-confirmation-input">Neues Passwort (Wiederholung):</label>
            <app-toggle-password>
                <input
                    id="password-confirmation-input"
                    #passwordInput
                    type="password"
                    [formControl]="formGroup.controls.newPasswordConfirmation"
                    placeholder="Neues Passwort (Wiederholung)"
                    autocomplete="new-password"
                />
                @if (
                    formGroup.controls.newPasswordConfirmation.touched &&
                    formGroup.controls.newPasswordConfirmation.invalid
                ) {
                    <span
                        class="form-error-note"
                        aria-live="polite"
                        >Die Passwörter passen nicht zueinander.</span
                    >
                }
            </app-toggle-password>
        </div>

        <app-portal-action-buttons
            class="g-12"
            confirmText="Speichern"
            rejectText="Abbrechen"
            confirmIcon="save"
            [isConfirmDisabled]="formGroup.pristine || formGroup.invalid || updating()"
            (clickReject)="close.emit()"
            [isUsedToSubmitForm]="true"
        />
    </div>
</form>
